function o(a) {
  const t = {};
  return Object.entries(a).forEach(([r, s]) => {
    !r.startsWith("aria") || r.startsWith("aria-") ? t[r] = s : t[`aria-${r.substring(4).toLowerCase()}`] = s;
  }), t;
}
function i(a) {
  const { biId: t, ...r } = a, s = o(r);
  return t && (s["data-bi-id"] = t), s;
}
export {
  i as f
};
//# sourceMappingURL=format-base-props-8NDUNDcL.mjs.map
